import { onMounted, onUnmounted } from 'vue'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { debounce } from '@backmarket/utils/function/debounce'

import { PaymentMeasure } from './constant'

const DEBOUNCE_REPORT_WAIT = 3000

export function usePaymentPerformanceReporter() {
  const logger = useLogger()

  const report = () => {
    const measures = []

    for (const [name, start, end] of PaymentMeasure) {
      try {
        measures.push(performance.measure(name, start, end))
      } catch {
        /* empty */
      }
    }

    if (measures.length === 0) {
      return
    }

    logger.info('[PAYIN] Payment page performance report', {
      owners: ['bot-squad-payin-front'],
      measures: measures.reduce(
        (acc, measure) => {
          // eslint-disable-next-line no-param-reassign
          acc[measure.name] = measure

          return acc
        },
        {} as Record<string, PerformanceMeasure>,
      ),
    })
  }

  const debouncedReport = debounce(report, DEBOUNCE_REPORT_WAIT)

  const measuresEndMarks = PaymentMeasure.map(([_name, _start, end]) => end)

  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if ((measuresEndMarks as string[]).includes(entry.name)) {
        debouncedReport()
      }
    }
  })

  onMounted(() => {
    observer.observe({ type: 'mark', buffered: true })
  })

  onUnmounted(() => {
    observer.disconnect()
  })
}
